var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty, Complex, Collection, Browser } from '@syncfusion/ej2-base';
import { Theme } from '../model/theme';
/**
 * Defines the appearance of the connectors
 */
export class Connector extends ChildProperty {
}
__decorate([
    Property('Line')
], Connector.prototype, "type", void 0);
__decorate([
    Property(null)
], Connector.prototype, "color", void 0);
__decorate([
    Property(1)
], Connector.prototype, "width", void 0);
__decorate([
    Property(null)
], Connector.prototype, "length", void 0);
__decorate([
    Property('')
], Connector.prototype, "dashArray", void 0);
/**
 * Configures the fonts in charts.
 */
export class Font extends ChildProperty {
}
__decorate([
    Property('Normal')
], Font.prototype, "fontStyle", void 0);
__decorate([
    Property('16px')
], Font.prototype, "size", void 0);
__decorate([
    Property('Normal')
], Font.prototype, "fontWeight", void 0);
__decorate([
    Property('')
], Font.prototype, "color", void 0);
__decorate([
    Property('Center')
], Font.prototype, "textAlignment", void 0);
__decorate([
    Property('Segoe UI')
], Font.prototype, "fontFamily", void 0);
__decorate([
    Property(1)
], Font.prototype, "opacity", void 0);
__decorate([
    Property('Wrap')
], Font.prototype, "textOverflow", void 0);
/**
 * Configures the borders in the chart.
 */
export class Border extends ChildProperty {
}
__decorate([
    Property('')
], Border.prototype, "color", void 0);
__decorate([
    Property(1)
], Border.prototype, "width", void 0);
/**
 * Configures the marker position in the chart.
 */
export class Offset extends ChildProperty {
}
__decorate([
    Property(0)
], Offset.prototype, "x", void 0);
__decorate([
    Property(0)
], Offset.prototype, "y", void 0);
/**
 * Configures the chart area.
 */
export class ChartArea extends ChildProperty {
}
__decorate([
    Complex({}, Border)
], ChartArea.prototype, "border", void 0);
__decorate([
    Property('transparent')
], ChartArea.prototype, "background", void 0);
__decorate([
    Property(1)
], ChartArea.prototype, "opacity", void 0);
__decorate([
    Property(null)
], ChartArea.prototype, "backgroundImage", void 0);
__decorate([
    Property(null)
], ChartArea.prototype, "width", void 0);
/**
 * Configures the chart margins.
 */
export class Margin extends ChildProperty {
}
__decorate([
    Property(Browser.isDevice ? 5 : 10)
], Margin.prototype, "left", void 0);
__decorate([
    Property(Browser.isDevice ? 5 : 10)
], Margin.prototype, "right", void 0);
__decorate([
    Property(Browser.isDevice ? 5 : 10)
], Margin.prototype, "top", void 0);
__decorate([
    Property(Browser.isDevice ? 5 : 10)
], Margin.prototype, "bottom", void 0);
/**
 * Configures the chart Legend Container Padding.
 */
export class ContainerPadding extends ChildProperty {
}
__decorate([
    Property(0)
], ContainerPadding.prototype, "left", void 0);
__decorate([
    Property(0)
], ContainerPadding.prototype, "right", void 0);
__decorate([
    Property(0)
], ContainerPadding.prototype, "top", void 0);
__decorate([
    Property(0)
], ContainerPadding.prototype, "bottom", void 0);
/**
 * Configures the animation behavior for chart series.
 */
export class Animation extends ChildProperty {
}
__decorate([
    Property(true)
], Animation.prototype, "enable", void 0);
__decorate([
    Property(1000)
], Animation.prototype, "duration", void 0);
__decorate([
    Property(0)
], Animation.prototype, "delay", void 0);
/**
 * Series and point index
 *
 * @public
 */
export class Indexes extends ChildProperty {
}
__decorate([
    Property(0)
], Indexes.prototype, "series", void 0);
__decorate([
    Property(0)
], Indexes.prototype, "point", void 0);
/**
 * Column series rounded corner options
 */
export class CornerRadius extends ChildProperty {
}
__decorate([
    Property(0)
], CornerRadius.prototype, "topLeft", void 0);
__decorate([
    Property(0)
], CornerRadius.prototype, "topRight", void 0);
__decorate([
    Property(0)
], CornerRadius.prototype, "bottomLeft", void 0);
__decorate([
    Property(0)
], CornerRadius.prototype, "bottomRight", void 0);
/**
 * @private
 */
export class Index {
    constructor(seriesIndex, pointIndex) {
        this.series = seriesIndex;
        this.point = pointIndex;
    }
}
/**
 * Configures the Empty Points of series
 */
export class EmptyPointSettings extends ChildProperty {
}
__decorate([
    Property(null)
], EmptyPointSettings.prototype, "fill", void 0);
__decorate([
    Complex({ color: 'transparent', width: 0 }, Border)
], EmptyPointSettings.prototype, "border", void 0);
__decorate([
    Property('Gap')
], EmptyPointSettings.prototype, "mode", void 0);
/**
 * Configures the drag settings of series
 */
export class DragSettings extends ChildProperty {
}
__decorate([
    Property(false)
], DragSettings.prototype, "enable", void 0);
__decorate([
    Property(null)
], DragSettings.prototype, "minY", void 0);
__decorate([
    Property(null)
], DragSettings.prototype, "maxY", void 0);
__decorate([
    Property(null)
], DragSettings.prototype, "fill", void 0);
/**
 * Configures the ToolTips in the chart.
 *
 * @public
 */
export class TooltipSettings extends ChildProperty {
}
__decorate([
    Property(false)
], TooltipSettings.prototype, "enable", void 0);
__decorate([
    Property(true)
], TooltipSettings.prototype, "enableMarker", void 0);
__decorate([
    Property(false)
], TooltipSettings.prototype, "shared", void 0);
__decorate([
    Property(null)
], TooltipSettings.prototype, "fill", void 0);
__decorate([
    Property(null)
], TooltipSettings.prototype, "header", void 0);
__decorate([
    Property(0.75)
], TooltipSettings.prototype, "opacity", void 0);
__decorate([
    Complex(Theme.tooltipLabelFont, Font)
], TooltipSettings.prototype, "textStyle", void 0);
__decorate([
    Property(null)
], TooltipSettings.prototype, "format", void 0);
__decorate([
    Property(null)
], TooltipSettings.prototype, "template", void 0);
__decorate([
    Property(true)
], TooltipSettings.prototype, "enableAnimation", void 0);
__decorate([
    Property(300)
], TooltipSettings.prototype, "duration", void 0);
__decorate([
    Property(1000)
], TooltipSettings.prototype, "fadeOutDuration", void 0);
__decorate([
    Property('Move')
], TooltipSettings.prototype, "fadeOutMode", void 0);
__decorate([
    Property(false)
], TooltipSettings.prototype, "enableTextWrap", void 0);
__decorate([
    Property(true)
], TooltipSettings.prototype, "showNearestPoint", void 0);
__decorate([
    Complex({ color: '#cccccc', width: 0.5 }, Border)
], TooltipSettings.prototype, "border", void 0);
/**
 * button settings in period selector
 */
export class Periods extends ChildProperty {
}
__decorate([
    Property('Years')
], Periods.prototype, "intervalType", void 0);
__decorate([
    Property(1)
], Periods.prototype, "interval", void 0);
__decorate([
    Property(null)
], Periods.prototype, "text", void 0);
__decorate([
    Property(false)
], Periods.prototype, "selected", void 0);
/**
 * Period Selector Settings
 */
export class PeriodSelectorSettings extends ChildProperty {
}
__decorate([
    Property(43)
], PeriodSelectorSettings.prototype, "height", void 0);
__decorate([
    Property('Bottom')
], PeriodSelectorSettings.prototype, "position", void 0);
__decorate([
    Collection([], Periods)
], PeriodSelectorSettings.prototype, "periods", void 0);
